import {Button, Modal, ModalBody, ModalContent, useDisclosure} from "@heroui/react";
import {twMerge} from 'tailwind-merge';
import UploadVideoModal from './UploadVideoModal.jsx';
import CreateProjectModal from './CreateProjectModal.jsx';
import {useEffect, useState} from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import {useBodyScrollLock} from '../helpers/hooks.jsx';
import {DotLottieReact} from "@lottiefiles/dotlottie-react";
import {includes} from "lodash";
import {useRecoilState} from "recoil";
import {useNavigate} from "react-router-dom";
import {userState} from "../store.jsx";

/**
 * NewProject Component
 * @param {import('@heroui/react').ButtonProps} [props.triggerProps] - Props for the trigger button
 */

const BaseModal = ({
					   title = "Upload your first video",
					   children,
					   data = null,
					   isClone = false,
					   triggerContent,
					   triggerProps,
					   ...props
				   }) => {
	const {isOpen, onOpen, onOpenChange, onClose: closedModal} = useDisclosure();
	const {isOpen: isOpenPopHover, onOpen: onOpenPopHover, onClose: onCloseOpenPopHover} = useDisclosure();
	const [locked, setLocked] = useBodyScrollLock();
	const {isOpen:buyPaidPlanModalIsOpen,  onOpenChange:buyPaidPlanModalOnOpenChange} = useDisclosure()
	const [authMe] = useRecoilState(userState)
	const navigate = useNavigate()



	const [submittedFile, setSubmittedFile] = useState(data || null);

	useEffect(() => {
		setLocked(isOpen)
		if (isOpen) {
			setSubmittedFile(null)
		}
	}, [isOpen]);

	const onDubbingClickHandler = () =>{
		if(includes([3, 5, 7, 9, 10], authMe?.current_plan))
		{
			onOpen()
		}
		else {
			buyPaidPlanModalOnOpenChange()
		}
	}


	return (
		<>
			<Button
				variant="flat"
				{...triggerProps}
				onPress={onDubbingClickHandler}
				className={twMerge([
					"bg-black text-white px-6 md:px-10 py-6 font-sans",
					triggerProps?.className
				])}>
				{'Create a Dub' || triggerContent}
			</Button>

			<AnimatePresence>
				{isOpen &&
					<motion.div
						initial={{
							opacity: 0,
							display: 'none'
						}}
						animate={{
							opacity: [0, 100],
							display: 'flex'
						}}
						exit={{
							opacity: [100, 0],
							display: 'none'

						}}
						className="bg-black/60 fixed backdrop-blur-[2px] left-0 top-0 w-full h-full flex justify-center items-center z-50">
						<div className="bg-white max-w-[600px] w-full rounded-3xl relative overflow-hidden border border-[#12131714] shadow-2xl">
							{/* gradient accent strip */}
							<div className="h-1.5 w-full bg-gradient-to-r from-[#7659fa] via-[#8a6cff] to-[#a78bfa]"></div>

							<div className="p-5">
								{/* wizard header */}
								<div className="flex flex-row justify-between items-center gap-1 mb-4">
									<div className="flex items-center gap-3">
										<div className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-[#7659fa1a] text-[#7659fa]">
											<i className={`hgi-stroke ${submittedFile ? 'hgi-folder-check' : 'hgi-cloud-upload'} text-xl`}></i>
										</div>
										<div>
											<h2 className="font-semibold font-sans text-slate-800">
												{submittedFile ? "Set up your project" : "Upload your first video"}
											</h2>
											<p className="text-xs text-slate-400">Step {submittedFile ? "2" : "1"} of 2</p>
										</div>
									</div>
									<Button onPress={closedModal} isIconOnly variant="light" color="danger">
										<i className="hgi-stroke hgi-cancel-01 text-xl"></i>
									</Button>
								</div>

								{/* step progress */}
								<div className="flex items-center gap-2 mb-5">
									<div className="h-1.5 flex-1 rounded-full bg-[#7659fa]"></div>
									<div className={`h-1.5 flex-1 rounded-full transition ${submittedFile ? 'bg-[#7659fa]' : 'bg-slate-200'}`}></div>
								</div>

								<div className="max-h-[600px] overflow-y-auto scrollbar-thin scrollbar-track-gray-100">
									{!submittedFile ? <UploadVideoModal onSubmitted={(response) => {
										setSubmittedFile(response)
									}}/> : <CreateProjectModal isClone onSubmitted={closedModal} data={submittedFile}/>}
								</div>
							</div>
						</div>
					</motion.div>
				}
			</AnimatePresence>


			{/*<Modal*/}
			{/*	classNames={{*/}
			{/*		base: 'rounded-3xl py-3',*/}
			{/*	}}*/}
			{/*	size="2xl"*/}
			{/*	backdrop="blur"*/}
			{/*	hideCloseButton*/}
			{/*	isOpen={false}>*/}
			{/*	<ModalContent>*/}
			{/*		<ModalHeader*/}
			{/*			className="flex flex-row justify-between items-center gap-1">*/}
			{/*			<h2>*/}
			{/*				{submittedFile ? "Setup you project" : "Upload your first video"}*/}
			{/*			</h2>*/}
			{/*			<Button onPress={onOpenChange} isIconOnly variant="light" color="danger">*/}
			{/*				<i className="hgi-stroke hgi-cancel-01 text-xl"></i>*/}
			{/*			</Button>*/}
			{/*		</ModalHeader>*/}
			{/*		<ModalBody className="max-h-961 overflow-y-auto">*/}
			{/*			{!submittedFile ? <UploadVideoModal onSubmitted={(response) => {*/}
			{/*				setSubmittedFile(response)*/}
			{/*			}}/> : <CreateProjectModal isClone onSubmitted={onOpenChange} data={submittedFile}/>}*/}
			{/*		</ModalBody>*/}
			{/*	</ModalContent>*/}
			{/*</Modal>*/}

			<Modal
				isDismissable={false}
				hideCloseButton
				backdrop="blur"
				size="lg"
				classNames={{
					base: 'overflow-hidden rounded-3xl border border-[#12131714] bg-white shadow-2xl',
					body: 'p-0'
				}}
				isOpen={buyPaidPlanModalIsOpen}>
				<ModalContent>
					{(onClose) => (
						<ModalBody>
							{/* Hero band — primary */}
							<div className="relative overflow-hidden bg-gradient-to-br from-[#7659fa] via-[#8a6cff] to-[#a78bfa] px-8 pt-9 pb-12">
								<div className="pointer-events-none absolute -top-10 -right-8 h-32 w-32 rounded-full bg-white/15 blur-2xl"></div>
								<div className="pointer-events-none absolute -bottom-12 -left-6 h-32 w-32 rounded-full bg-white/10 blur-2xl"></div>
								<div className="relative flex flex-col items-center text-center">
									<div className="grid h-16 w-16 place-items-center rounded-2xl bg-white/20 backdrop-blur-sm ring-1 ring-white/40">
										<i className="hgi-stroke hgi-rocket-01 text-3xl text-white"></i>
									</div>
									<h2 className="mt-4 text-xl font-semibold text-white">Upgrade to a paid plan</h2>
									<p className="mt-1 max-w-sm text-sm font-light text-white/80">
										Unlock premium dubbing and more.
									</p>
								</div>
							</div>

							{/* Lottie + copy */}
							<div className="relative -mt-6 px-6">
								<div className="rounded-2xl border border-[#12131714] bg-[#fcfcfd] p-4 text-center shadow-sm">
									<div className="mx-auto max-w-[220px]">
										<DotLottieReact
											src="/lottie/paid-plan.lottie"
											loop
											autoplay
										/>
									</div>
									<p className="text-sm font-light leading-relaxed text-slate-500">
										To use our Premium Dubbing feature, you need to subscribe to a paid plan. Choose the one that suits you best and unlock premium features today!
									</p>
								</div>
							</div>

							{/* Actions */}
							<div className="flex justify-end gap-3 px-6 py-5">
								<Button
									onPress={buyPaidPlanModalOnOpenChange}
									variant="bordered"
									className="h-11 rounded-xl border-1 border-[#00000014] bg-[#c8ceda4d] px-6 text-sm font-medium text-slate-700 hover:border-slate-700">
									Maybe later
								</Button>
								<Button
									className="h-11 rounded-xl bg-[#7659fa] px-6 text-sm font-medium text-white shadow-lg shadow-[#7659fa40] transition hover:opacity-95"
									onPress={() => {
										navigate("/user/plans")
									}}>
									<i className="hgi-stroke hgi-rocket-01 text-[15px]"></i> Purchase Now
								</Button>
							</div>
						</ModalBody>
					)}
				</ModalContent>
			</Modal>
		</>
	)
};

export default BaseModal;
